export default "__VITE_ASSET__CM5kiZqV__"